<template>
  <zj-layout-container class="content patrol-home">
    <zj-layout-main>
      <div class="zj-layout-main-content scrollable">
        <div class="patrol-home-top">
          <div class="title">今日巡检</div>
          <div class="patrol-nums">
            <div class="nums-item" v-for="(item, index) in list" :key="index">
              <div class="nums-title">{{ item.title }}</div>
              <div class="nums-value">
                <div
                  v-for="ite in item.taskNum"
                  class="nums-value-img"
                  :key="ite"
                >
                  <img :src="ite" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="patrol-home-bottom">
          <div class="title">巡检异常</div>
          <div @click="toMoreInfo" class="moreInfo">更多></div>
          <div class="patrol-home-content scrollable">
            <div class="zj-table-container">
              <el-table
                :data="tableData"
                border
                ref="multipleTable"
                style="width: 100%"
                fixed
              >
                <el-table-column prop="name" label="计划名称">
                </el-table-column>
                <el-table-column
                  prop="staffName"
                  label="巡检人员"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="startdate"
                  label="开始时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="singlePatroltime"
                  label="执行时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="statusName"
                  label="异常类型"
                  align="center"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </zj-layout-main>
  </zj-layout-container>
</template>

<script>
import num0 from "../../theme-default/images/0.png";
import num1 from "../../theme-default/images/1.png";
import num2 from "../../theme-default/images/2.png";
import num3 from "../../theme-default/images/3.png";
import num4 from "../../theme-default/images/4.png";
import num5 from "../../theme-default/images/5.png";
import num6 from "../../theme-default/images/6.png";
import num7 from "../../theme-default/images/7.png";
import num8 from "../../theme-default/images/8.png";
import num9 from "../../theme-default/images/9.png";
import {
  getStatistical,
  getPatrolTaskList,
  findOneTreeBySysCode,
} from "@/request/patrolApi";
export default {
  name: "ZjPatrolHome",
  controller: "UI",
  action: "Home",
  data() {
    return {
      tableData: [],
      numArr: [num0, num1, num2, num3, num4, num5, num6, num7, num8, num9],
      list: [
        {
          title: "巡检任务",
          taskNum: [0, 1, 2],
        },
        {
          title: "已完成任务",
          taskNum: [2, 3, 4],
        },
        {
          title: "临时任务",
          taskNum: [5, 6, 7],
        },
        {
          title: "巡检异常",
          taskNum: [7, 8, 9],
        },
      ],
      culturaCodes: "", // 根据code获取组织结构列表code
      organization: "", // 从登录获取组织机构code
    };
  },
  created() {
    this.list[0].taskNum = this.addZero(0, 3);
    this.list[1].taskNum = this.addZero(0, 3);
    this.list[2].taskNum = this.addZero(0, 3);
    this.list[3].taskNum = this.addZero(0, 3);

    this.getmCulturaCompany();
    this.getPatrolTaskList();
  },
  mounted() {
    // this.$store.dispatch('submitIsShowbg', false);
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    toMoreInfo() {
      this.$router.push({
        path: "/plugin/Patrol/UI/Abnormal",
        query: {
          jump: true
        },
      });
    },
    addZero(value, length) {
      let arr = [];
      value = value + "";
      if (value.length == 1 && length == 3) {
        arr.push(this.numArr[0]);
        arr.push(this.numArr[0]);
        arr.push(this.numArr[value]);
      } else if (value.length == 2 && length == 3) {
        let temp = value.split("");
        arr.push(this.numArr[0]);
        arr.push(this.numArr[temp[0]]);
        arr.push(this.numArr[temp[1]]);
      } else if (value.length == 3 && length == 3) {
        let temp = value.split("");
        arr.push(this.numArr[temp[0]]);
        arr.push(this.numArr[temp[1]]);
        arr.push(this.numArr[temp[2]]);
      } else if (value.length == 1 && length == 5) {
        arr.push(this.numArr[0]);
        arr.push(this.numArr[0]);
        arr.push(this.numArr[0]);
        arr.push(this.numArr[0]);
        arr.push(this.numArr[value]);
      } else if (value.length == 2 && length == 5) {
        let temp = value.split("");
        arr.push(this.numArr[0]);
        arr.push(this.numArr[0]);
        arr.push(this.numArr[0]);
        arr.push(this.numArr[temp[0]]);
        arr.push(this.numArr[temp[1]]);
      } else if (value.length == 3 && length == 5) {
        let temp = value.split("");
        arr.push(this.numArr[0]);
        arr.push(this.numArr[0]);
        arr.push(this.numArr[temp[0]]);
        arr.push(this.numArr[temp[1]]);
        arr.push(this.numArr[temp[2]]);
      } else if (value.length == 4 && length == 5) {
        let temp = value.split("");
        arr.push(this.numArr[0]);
        arr.push(this.numArr[temp[0]]);
        arr.push(this.numArr[temp[1]]);
        arr.push(this.numArr[temp[2]]);
        arr.push(this.numArr[temp[3]]);
      } else if (value.length == 5 && length == 5) {
        let temp = value.split("");
        arr.push(this.numArr[temp[0]]);
        arr.push(this.numArr[temp[1]]);
        arr.push(this.numArr[temp[2]]);
        arr.push(this.numArr[temp[3]]);
        arr.push(this.numArr[temp[4]]);
      }
      return arr;
    },
    // 获取单位code
    getmCulturaCompany() {
      this.organization = this.user.userInfo.organization[0].code;
      let searchInfo = {
        perAreaType: "",
        perAreaCodes: "",
        organizationCode: this.organization,
      };
      findOneTreeBySysCode(searchInfo)
        .then((res) => {
          let culturaList = [];
          if (res.code === 0 && res.data) {
            let data = res.data;
            if (data.list.length > 0) {
              data.list.map((item) => {
                culturaList.push(item.code);
              });
              this.culturaCodes = culturaList.join(",");
              this.getStatistical();
            }
          } else {
            // this.errmsg(res.msg);
          }
        })
        .catch((e) => {
          this.errmsg(e.msg ? e.msg : "服务异常，请联系管理员！");
        });
    },
    // 获取首页数据
    getStatistical() {
      let searchInfo = {
        culturaCompanyCode: this.culturaCodes,
        code: this.organization,
      };
      getStatistical(searchInfo)
        .then((res) => {
          if (res.code === 0 && res.data) {
            let data = res.data;
            this.list[0].taskNum = this.addZero(data.patrolTaskNum, 3);
            this.list[1].taskNum = this.addZero(data.endTaskNum, 3);
            this.list[2].taskNum = this.addZero(data.temporaryNum, 3);
            this.list[3].taskNum = this.addZero(data.unusualNum, 3);
          } else {
            this.errmsg(res.msg);
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.msg ? e.msg : "服务异常，请联系管理员！");
        });
    },
    getPatrolTaskList() {
      let searchInfo = {
        taskSource: 1,
        staffName: "",
        planname: "",
        status: "6",
        startdates: new Date().format("yyyy-MM-dd") + ',' + new Date().format("yyyy-MM-dd"),
        page: 1,
        size: 6,
      };
      getPatrolTaskList(searchInfo)
        .then((r) => {
          if (r.code === 0 && r.data) {
            this.tableData = r.data;
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.msg ? e.msg : "服务异常，请联系管理员！");
        });
    },
  },
  beforeDestroy() {
    // this.$store.dispatch('submitIsShowbg', true)
  },
};
</script>
<style scoped>
.patrol-home {
  padding: 0;
}
.patrol-home-top {
  box-sizing: border-box;
  border-bottom: 0.1rem dashed #00bcfe;
  /* background: #003669; */
  padding-bottom: 3rem;
  position: relative;
}
.patrol-nums {
  display: flex;
  justify-content: space-between;
  margin-top: 5rem;
}
.nums-item {
}
.nums-title {
  font-size: 1.4rem;
  text-align: center;
  margin-bottom: 2rem;
}
.nums-value {
  display: flex;
  justify-content: center;
}
.nums-value-img {
  display: flex;
  justify-content: center;
  width: 5.4rem;
  height: 6.7rem;
  background: url("../../theme-default/images/numberBorder.png") no-repeat
    center;
  background-size: 100% 100%;
  align-items: center;
}
.nums-value-img img {
  width: 3.4rem;
  height: 5rem;
  object-fit: cover;
}
.patrol-home-bottom {
  position: relative;
  flex: 1;
  /* border: 0.1rem solid #00bcfe; */
  /* background: #003669; */
  padding: 3rem 0;
}
.patrol-home-bottom a {
  position: absolute;
  right: 5rem;
  top: 3rem;
  color: #fff;
  text-decoration: none;
}
.title {
  position: relative;
  text-align: center;
}
.title::after {
  content: "";
  width: 4rem;
  height: 0.1rem;
  position: absolute;
  left: calc(50% - 2rem);
  bottom: -1rem;
  background-image: linear-gradient(90deg, #00bcfe, #4ed1ff),
    linear-gradient(#000, #000);
}
.patrol-home-content {
  margin-top: 3rem;
}
.moreInfo{
  float: right;
  cursor: pointer;
}
</style>
